var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import InputMask from 'react-input-mask';
import { TextField } from '@mui/material';
var getLabelObrigatorio = function (label, required) {
    if (typeof label !== 'string')
        return label;
    if (required) {
        return label.replace(/[\s*]+$/, '');
    }
    return label;
};
export var InputDados = function (props) {
    var _a, _b, _c;
    var multiline = props.multiline, select = props.select, maxLength = props.maxLength, value = props.value, defaultValue = props.defaultValue, helperText = props.helperText, rest = __rest(props, ["multiline", "select", "maxLength", "value", "defaultValue", "helperText"]);
    var label = getLabelObrigatorio(props.label, props.required);
    var inputLabelProps = __assign(__assign({}, props.InputLabelProps), { shrink: (_b = (_a = props.InputLabelProps) === null || _a === void 0 ? void 0 : _a.shrink) !== null && _b !== void 0 ? _b : !!value });
    if (multiline) {
        var currentLength = String((_c = value !== null && value !== void 0 ? value : defaultValue) !== null && _c !== void 0 ? _c : '').length;
        var computedHelperText = maxLength ? "".concat(currentLength, "/").concat(maxLength).concat(helperText ? " - ".concat(helperText) : '') : helperText;
        return (_jsx(TextField, __assign({ size: 'small' }, props, { label: label, minRows: 4, fullWidth: true, inputProps: __assign({ maxLength: maxLength }, props.inputProps), helperText: computedHelperText })));
    }
    else {
        if (select) {
            return _jsx(TextField, __assign({ size: 'small' }, props, { label: label, fullWidth: true }));
        }
        else if (!props.mask) {
            return _jsx(TextField, __assign({ size: 'small', inputProps: { maxLength: maxLength !== null && maxLength !== void 0 ? maxLength : 100 } }, props, { label: label, InputLabelProps: inputLabelProps, fullWidth: true }));
        }
        else {
            return (_jsx(InputMask, __assign({ maskChar: null, value: value }, rest, { children: function (inputProps) { return (_jsx(TextField, __assign({ size: 'small' }, inputProps, { label: label, InputLabelProps: inputLabelProps, inputProps: { maxLength: maxLength !== null && maxLength !== void 0 ? maxLength : 100 }, fullWidth: true }))); } })));
        }
    }
};
export default InputDados;
export var InputDados2 = function (props) {
    var _a, _b, _c;
    var multiline = props.multiline, select = props.select, maxLength = props.maxLength, inputProps = props.inputProps, value = props.value, defaultValue = props.defaultValue, helperText = props.helperText, rest = __rest(props, ["multiline", "select", "maxLength", "inputProps", "value", "defaultValue", "helperText"]);
    var label = getLabelObrigatorio(props.label, props.required);
    var mergedInputLabelProps = __assign(__assign({}, props.InputLabelProps), { shrink: (_b = (_a = props.InputLabelProps) === null || _a === void 0 ? void 0 : _a.shrink) !== null && _b !== void 0 ? _b : !!value });
    var combinedInputProps = __assign(__assign({}, inputProps), (maxLength && { maxLength: maxLength }));
    if (multiline) {
        // Calcula o contador apenas para o multiline
        var currentLength = String((_c = value !== null && value !== void 0 ? value : defaultValue) !== null && _c !== void 0 ? _c : '').length;
        var computedHelperText = maxLength ? "".concat(currentLength, "/").concat(maxLength).concat(helperText ? " - ".concat(helperText) : '') : helperText;
        return (_jsx(TextField, __assign({ size: 'small' }, rest, { value: value, defaultValue: defaultValue, label: label, minRows: 4, fullWidth: true, inputProps: combinedInputProps, helperText: computedHelperText })));
    }
    else if (select) {
        return _jsx(TextField, __assign({ size: 'small' }, rest, { label: label, fullWidth: true, inputProps: combinedInputProps }));
    }
    else {
        return (_jsx(InputMask, __assign({}, rest, { children: function (inputPropsMasked) { return (_jsx(TextField, __assign({ size: 'small' }, inputPropsMasked, rest, { label: label, inputProps: __assign(__assign({}, inputPropsMasked.inputProps), combinedInputProps), InputLabelProps: mergedInputLabelProps, fullWidth: true }))); } })));
    }
};
